module.exports = __webpack_public_path__ + "img/0daf0bb0cfd240e4315c1865d6f85509.5c56712e.png";